import { useAppSelector } from '@/store/hooks';
import { selectUser } from '@/store/slices/authSlice';

/**
 * Name of the internal NVX management organization in Auth0. When the active
 * Auth0 user belongs to this org they are an NVX administrator who has logged
 * in against a customer tenant — we surface the impersonation banner so they
 * never lose track of which tenant they are operating on.
 */
export const MANAGEMENT_ORG_NAME = 'nvx-management';

/**
 * Single source of truth for whether the {@link CustomerAdminBanner} is shown.
 * Both the banner itself and the outer {@link AppLayout} consume this so the
 * layout can reserve vertical space only when the banner is actually rendered.
 */
export function useIsCustomerAdminBannerVisible(): boolean {
  const user = useAppSelector(selectUser);
  return user?.orgName?.toLowerCase() === MANAGEMENT_ORG_NAME;
}
